/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CompanyIdentityFinancingMigrationRequest
 */
export interface CompanyIdentityFinancingMigrationRequest {
    /**
     * Company identity IDs to migrate. If empty, all IDs are streamed via companyIdentityRepository.streamAllIds().
     * @type {Array<string>}
     * @memberof CompanyIdentityFinancingMigrationRequest
     */
    companyIdentityIds?: Array<string>;
}

/**
 * Check if a given object implements the CompanyIdentityFinancingMigrationRequest interface.
 */
export function instanceOfCompanyIdentityFinancingMigrationRequest(value: object): value is CompanyIdentityFinancingMigrationRequest {
    return true;
}

export function CompanyIdentityFinancingMigrationRequestFromJSON(json: any): CompanyIdentityFinancingMigrationRequest {
    return CompanyIdentityFinancingMigrationRequestFromJSONTyped(json, false);
}

export function CompanyIdentityFinancingMigrationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyIdentityFinancingMigrationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'companyIdentityIds': json['companyIdentityIds'] == null ? undefined : json['companyIdentityIds'],
    };
}

export function CompanyIdentityFinancingMigrationRequestToJSON(value?: CompanyIdentityFinancingMigrationRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'companyIdentityIds': value['companyIdentityIds'],
    };
}

